import { Navigate } from "react-router-dom";
import PublicRoute from "../services/routes/PublicRoute";
import PrivateRoute from "../services/routes/PrivateRoute";
import Layout from "../components/layout/Layout";
import Login from "../pages/Login/index.jsx";
import Dashboard from "../pages/Dashboard/index.jsx";
import OrganCategory from "../pages/OrganCategory/index.jsx";
import OrganCategoryForm from "../pages/OrganCategory/form.jsx";
import TeamMember from "../pages/TeamMember/index.jsx";
import TeamMemberForm from "../pages/TeamMember/form.jsx";
import DonorReview from "../pages/DonorReview/index.jsx";
import DonorReviewForm from "../pages/DonorReview/form.jsx";
import EventCategory from "../pages/EventCategory/index.jsx";
import EventCategoryForm from "../pages/EventCategory/form.jsx";
import PressCategoryForm from "../pages/PressCategory/form.jsx";
import PhotoGallery from "../pages/PhotoGallery/index.jsx";
import PhotoGalleryForm from "../pages/PhotoGallery/form.jsx";
import PressCategory from "../pages/PressCategory/index.jsx";
import Video from "../pages/VideoSection/index.jsx";
import VideoForm from "../pages/VideoSection/form.jsx";
import Blogs from "../pages/Blogs/index.jsx";
import BlogsForm from "../pages/Blogs/form.jsx";
import ElectronicMedia from "../pages/ElectricMedia/index.jsx";
import ElectronicMediaForm from "../pages/ElectricMedia/form.jsx";
import DigitalMedia from "../pages/DigitalMedia/index.jsx";
import DigitalMediaForm from "../pages/DigitalMedia/form.jsx";
import DonorApplication from "../pages/DonorApplication/index.jsx";
import DonorApplicationForm from "../pages/DonorApplication/form.jsx";
import Payment from "../pages/DonatePayments/index.jsx";

// Define private routes configuration
const privateRoutes = [
  { path: "/dashboard", Component: Dashboard },
  { path: "/organ-category", Component: OrganCategory },
  { path: "/payment", Component: Payment },
  { path: "/organ-category-form", Component: OrganCategoryForm },
  { path: "/team-member", Component: TeamMember },
  { path: "/team-member-form", Component: TeamMemberForm },
  { path: "/donor-review", Component: DonorReview },
  { path: "/donor-review-form", Component: DonorReviewForm },
  { path: "/event-category", Component: EventCategory },
  { path: "/event-category-form", Component: EventCategoryForm },
  { path: "/press-coverage-category", Component: PressCategory },
  { path: "/pressCoverage-category-form", Component: PressCategoryForm },
  { path: "/photo-gallery", Component: PhotoGallery },
  { path: "/photo-gallery-form", Component: PhotoGalleryForm },
  { path: "/blogs", Component: Blogs },
  { path: "/blogs-form", Component: BlogsForm },
  { path: "/video-gallery", Component: Video },
  { path: "/video-gallery-form", Component: VideoForm },
  { path: "/electronic-media", Component: ElectronicMedia },
  { path: "/electronic-media-form", Component: ElectronicMediaForm },
  { path: "/digital-media", Component: DigitalMedia },
  { path: "/digital-media-form", Component: DigitalMediaForm },
  { path: "/donor-application", Component: DonorApplication },
  { path: "/donor-application-form/:id", Component: DonorApplicationForm },
];

// Generate private routes with Layout wrapper
const generatePrivateRoutes = () =>
  privateRoutes.map(({ path, Component }) => ({
    path,
    element: (
      <PrivateRoute>
        <Layout>
          <Component />
        </Layout>
      </PrivateRoute>
    ),
  }));

const appRoutes = [
  {
    path: "/login",
    element: (
      <PublicRoute>
        <Login />
      </PublicRoute>
    ),
  },
  ...generatePrivateRoutes(),
  {
    path: "*",
    element: <Navigate to="/login" replace />,
  },
];

export default appRoutes;
